import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'typeOfVoiceControl',
  standalone: false,
})
export class TypeOfVoiceControlPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: string): any {
    let type: string = '';

    switch (value) {
      case AppConst.VOICE_CONTROL_TYPE_OFF:
      type = this.translate.instant('音声自動再生OFF');
      break;
      case AppConst.VOICE_CONTROL_TYPE_ON_CURRENT_10M:
      type = this.translate.instant('音声自動再生ON（現在地から10m範囲内）');
      break;
      case AppConst.VOICE_CONTROL_TYPE_ON_CURRENT_20M:
      type = this.translate.instant('音声自動再生ON（現在地から20m範囲内）');
      break;
      case AppConst.VOICE_CONTROL_TYPE_ON_CURRENT_50M:
      type = this.translate.instant('音声自動再生ON（現在地から50m範囲内）');
      break;
    }
    return type;
  }

}
